const serviceWorkerUpdaterActions = {
  SET_UPDATE_PENDING: 'SET_UPDATE_PENDING',

  setUpdatePending: (payload: boolean) => ({
    type: serviceWorkerUpdaterActions.SET_UPDATE_PENDING,
    payload,
  }),
};

export default serviceWorkerUpdaterActions;
